import {
  BaseplateSize,
  LegoColor,
  LegoPattern,
  BrickInventory,
  LegoSize,
} from '../types/LegoTypes';
import { buildPlateInventoryKey, getPlateStudSize } from '../types/legoPlates';
import { getLettersPerBaseplate } from './legoLayout';

const createPattern = (pixels: boolean[][], color: LegoColor): LegoPattern => ({
  pixels,
  color,
});

// Definim els patrons de les lletres
export const letterPatterns: { [key: string]: LegoPattern } = {
  A: createPattern(
    [
      [true, true, true, true, true],
      [true, false, false, false, true],
      [true, true, true, true, true],
      [true, false, false, false, true],
      [true, false, false, false, true],
    ],
    'red',
  ),

  B: createPattern(
    [
      [true, true, true, true, false],
      [true, false, false, false, true],
      [true, true, true, true, false],
      [true, false, false, false, true],
      [true, true, true, true, false],
    ],
    'orange',
  ),

  C: createPattern(
    [
      [true, true, true, true, true],
      [true, false, false, false, false],
      [true, false, false, false, false],
      [true, false, false, false, false],
      [true, true, true, true, true],
    ],
    'blue',
  ),

  D: createPattern(
    [
      [true, true, true, true, false],
      [true, false, false, false, true],
      [true, false, false, false, true],
      [true, false, false, false, true],
      [true, true, true, true, false],
    ],
    'purple',
  ),

  E: createPattern(
    [
      [true, true, true, true, true],
      [true, false, false, false, false],
      [true, true, true, true, false],
      [true, false, false, false, false],
      [true, true, true, true, true],
    ],
    'yellow',
  ),

  F: createPattern(
    [
      [true, true, true, true, true],
      [true, false, false, false, false],
      [true, true, true, true, false],
      [true, false, false, false, false],
      [true, false, false, false, false],
    ],
    'green',
  ),

  G: createPattern(
    [
      [true, true, true, true, true],
      [true, false, false, false, false],
      [true, false, true, true, true],
      [true, false, false, false, true],
      [true, true, true, true, true],
    ],
    'blue',
  ),

  H: createPattern(
    [
      [true, false, false, false, true],
      [true, false, false, false, true],
      [true, true, true, true, true],
      [true, false, false, false, true],
      [true, false, false, false, true],
    ],
    'red',
  ),

  I: createPattern(
    [
      [true, true, true, true, true],
      [false, false, true, false, false],
      [false, false, true, false, false],
      [false, false, true, false, false],
      [true, true, true, true, true],
    ],
    'orange',
  ),

  J: createPattern(
    [
      [false, false, false, false, true],
      [false, false, false, false, true],
      [false, false, false, false, true],
      [true, false, false, false, true],
      [true, true, true, true, true],
    ],
    'blue',
  ),

  K: createPattern(
    [
      [true, false, false, false, true],
      [true, false, false, true, false],
      [true, true, true, false, false],
      [true, false, false, true, false],
      [true, false, false, false, true],
    ],
    'purple',
  ),

  L: createPattern(
    [
      [true, false, false, false, false],
      [true, false, false, false, false],
      [true, false, false, false, false],
      [true, false, false, false, false],
      [true, true, true, true, true],
    ],
    'yellow',
  ),

  M: createPattern(
    [
      [true, false, false, false, true],
      [true, true, false, true, true],
      [true, false, true, false, true],
      [true, false, false, false, true],
      [true, false, false, false, true],
    ],
    'green',
  ),

  N: createPattern(
    [
      [true, false, false, false, true],
      [true, true, false, false, true],
      [true, false, true, false, true],
      [true, false, false, true, true],
      [true, false, false, false, true],
    ],
    'blue',
  ),

  O: createPattern(
    [
      [true, true, true, true, true],
      [true, false, false, false, true],
      [true, false, false, false, true],
      [true, false, false, false, true],
      [true, true, true, true, true],
    ],
    'red',
  ),

  P: createPattern(
    [
      [true, true, true, true, true],
      [true, false, false, false, true],
      [true, true, true, true, true],
      [true, false, false, false, false],
      [true, false, false, false, false],
    ],
    'orange',
  ),

  Q: createPattern(
    [
      [true, true, true, true, true],
      [true, false, false, false, true],
      [true, false, true, false, true],
      [true, false, false, true, false],
      [true, true, true, false, true],
    ],
    'blue',
  ),

  R: createPattern(
    [
      [true, true, true, true, true],
      [true, false, false, false, true],
      [true, true, true, true, true],
      [true, false, false, true, false],
      [true, false, false, false, true],
    ],
    'purple',
  ),

  S: createPattern(
    [
      [true, true, true, true, true],
      [true, false, false, false, false],
      [true, true, true, true, true],
      [false, false, false, false, true],
      [true, true, true, true, true],
    ],
    'yellow',
  ),

  T: createPattern(
    [
      [true, true, true, true, true],
      [false, false, true, false, false],
      [false, false, true, false, false],
      [false, false, true, false, false],
      [false, false, true, false, false],
    ],
    'green',
  ),

  U: createPattern(
    [
      [true, false, false, false, true],
      [true, false, false, false, true],
      [true, false, false, false, true],
      [true, false, false, false, true],
      [true, true, true, true, true],
    ],
    'blue',
  ),

  V: createPattern(
    [
      [true, false, false, false, true],
      [true, false, false, false, true],
      [true, false, false, false, true],
      [false, true, false, true, false],
      [false, false, true, false, false],
    ],
    'red',
  ),

  W: createPattern(
    [
      [true, false, false, false, true],
      [true, false, false, false, true],
      [true, false, true, false, true],
      [true, true, false, true, true],
      [true, false, false, false, true],
    ],
    'orange',
  ),

  X: createPattern(
    [
      [true, false, false, false, true],
      [false, true, false, true, false],
      [false, false, true, false, false],
      [false, true, false, true, false],
      [true, false, false, false, true],
    ],
    'blue',
  ),

  Y: createPattern(
    [
      [true, false, false, false, true],
      [false, true, false, true, false],
      [false, false, true, false, false],
      [false, false, true, false, false],
      [false, false, true, false, false],
    ],
    'purple',
  ),

  Z: createPattern(
    [
      [true, true, true, true, true],
      [false, false, false, true, false],
      [false, false, true, false, false],
      [false, true, false, false, false],
      [true, true, true, true, true],
    ],
    'yellow',
  ),

  // ... continuaré amb la resta de lletres si vols ...
};

export const calculateBrickInventory = (
  name: string,
  size: LegoSize,
  baseplate: BaseplateSize,
): BrickInventory => {
  const inventory: BrickInventory = {};
  // Calculem baseplates necessàries
  const lettersPerBase = getLettersPerBaseplate(size, baseplate);
  const baseplatesNeeded = Math.ceil(name.length / lettersPerBase);
  const baseplateKey = `${baseplate} baseplate`;
  inventory[baseplateKey] = baseplatesNeeded;

  // Per cada lletra, calculem les peces necessàries
  name
    .toUpperCase()
    .split('')
    .forEach((letter) => {
      const pattern = letterPatterns[letter];
      if (!pattern) return;

      const plateStuds = getPlateStudSize(size);
      const plateKey = buildPlateInventoryKey(plateStuds, pattern.color);

      pattern.pixels.forEach((row) => {
        row.forEach((pixel) => {
          if (pixel) {
            inventory[plateKey] = (inventory[plateKey] || 0) + 1;
          }
        });
      });
    });

  return inventory;
};
